var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "base-settings-page" } },
    [
      _vm.title || _vm.showSearch || _vm.showAddButton
        ? _c(
            "div",
            { staticClass: "header" },
            [
              _vm.title
                ? _c(
                    "div",
                    { staticClass: "title" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "text",
                          attrs: { "data-text": "settings-page-title" },
                        },
                        [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
                      ),
                      _vm._v(" "),
                      _vm._t("title-append"),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("transition", { attrs: { name: "header-actions" } }, [
                _vm.showSearch || _vm.showAddButton
                  ? _c(
                      "div",
                      {
                        staticClass: "header-actions",
                        class: { "is-saving": _vm.isUpdating },
                      },
                      [
                        _vm.showSearch
                          ? _c("or-search", {
                              attrs: {
                                "data-input": "search",
                                "model-value": _vm.searchInputValue,
                                placeholder: _vm.searchPlaceholderText,
                                disabled:
                                  _vm.isInitializing ||
                                  _vm.isUpdating ||
                                  _vm.isDisabled,
                              },
                              on: {
                                search: function ($event) {
                                  return _vm.$emit("search", $event || "")
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showAddButton
                          ? _c(
                              "or-button",
                              {
                                attrs: {
                                  "data-button": "add-item",
                                  disabled:
                                    _vm.isInitializing ||
                                    _vm.isUpdating ||
                                    _vm.isDisabled,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("add-button-click")
                                  },
                                },
                              },
                              [
                                _c("or-icon", { attrs: { icon: "add" } }),
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t(
                                        "HITL.modules.common-settings.create-new-label"
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "pre-content" }, [_vm._t("pre-content")], 2),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content",
          class: { "is-loading": _vm.isInitializing || _vm.isSearching },
        },
        [
          _vm.isInitializing || _vm.isSearching ? _c("or-loader") : _vm._e(),
          _vm._v(" "),
          !_vm.isInitializing && !_vm.isSearching
            ? _vm._t("content")
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "sidebar-panel-appear", appear: "" } },
        [
          _vm.showSidebar
            ? _c(
                "div",
                {
                  staticClass: "sidebar-panel",
                  attrs: { "data-component": "sidebar" },
                },
                [_vm._t("sidebar")],
                2
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }